var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_photo_alternate",
    clipPath: "url(#clip0_11479_10881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9974 16.6654H3.33073V4.9987H10.8307V3.33203H3.33073C2.41406 3.33203 1.66406 4.08203 1.66406 4.9987V16.6654C1.66406 17.582 2.41406 18.332 3.33073 18.332H14.9974C15.9141 18.332 16.6641 17.582 16.6641 16.6654V9.16536H14.9974V16.6654ZM8.50573 14.0237L6.8724 12.057L4.58073 14.9987H13.7474L10.7974 11.0737L8.50573 14.0237ZM16.6641 3.33203V0.832031H14.9974V3.33203H12.4974C12.5057 3.34036 12.4974 4.9987 12.4974 4.9987H14.9974V7.49036C15.0057 7.4987 16.6641 7.49036 16.6641 7.49036V4.9987H19.1641V3.33203H16.6641Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11479_10881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7dfcd88fce4eb43d0673d459a161e9cc.svg";
export { ForwardRef as ReactComponent };